export default __webpack_public_path__ + "static/media/container.85153a16.svg";